import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  createRef,
  memo,
} from "react";
import { Store } from "../state/state";
import getAllHijirDate from "../function/getAllHijriDate";
import calender1440 from "../data-contents/1442.json";
import Calender from "./Templates/Calender/Calender";
import { useObserver } from "mobx-react";
import {
  exportComponentAsJPEG,
  exportComponentAsPDF,
  exportComponentAsPNG,
} from "react-component-export-image";

function MainPanel() {
  const [currentMonth, setCurrentMonth] = useState({ monthName: "", date: [] });
  let [select, setSelect] = useState(0);
  const [animation, setAnimation] = useState(false);
  const [direction, setDirection] = useState("right");
  const calenderRef = createRef();
  const store = useContext(Store);

  useEffect(() => {
    let data = getAllHijirDate();
    console.log(data);
    let result = [];
    store.setCalenderResult(calender1440);
  }, []);
  //   const test = () => {
  //     html12canvas(document.querySelector("#calender")).then(function (canvas) {
  //       document.body.appendChild(canvas);
  //       var base64URL = canvas
  //         .toDataURL("image/jpeg")
  //         .replace("image/jpeg", "image/octet-stream");
  //       console.log(base64URL);
  //     });
  //   };
  const onPrint = () => {
    const g = document.querySelector("#calender");
    console.log(calenderRef);
    console.log(g);
    exportComponentAsPDF(g);
  };
  // useEffect(() => {
  //   let calenderPanel = document.querySelector("#main-calender");
  //   calenderPanel.addEventListener("click", (e) => {});
  // }, []);
  const onRight = () => {
    setAnimation(!animation);
    setDirection("right");
    setSelect(++select);
  };
  const onLeft = () => {
    setDirection("left");
    setAnimation(!animation);

    setSelect(--select);
  };
  return useObserver(() => (
    <div
      id="main-calender"
      className="     h-screen  transition-all duration-700 "
      style={{
        // width: store.preview ? "80vw" : "80vw",
        width: "80vw",
        flex: 1,
        // transform: store.preview ? "translateX(25vw) " : "translateX(0px)",
      }}
      onClick={(e) => {
        let id = e.target.getAttribute("id");
        console.log("id :", id);
        console.log("select ", e.target);
        if (id === "empty") {
          store.clearSelect();
          store.selectEditor = "";
        } else if (id !== null) store.setSelect(id);
      }}
    >
      <div
        id={"empty"}
        className="flex-1 flex justify-around items-center relative  "
      >
        {store.calenderRuslt.length > 0 && (
          <Calender
            ref={(ref) => {
              console.log("ref :", ref);
            }}
            select={select}
            start={async () => await setSelect(0)}
            onAdd={() => setSelect(++select)}
            direction={direction}
            animation={animation}
            data={store.calenderRuslt[select]}
            conditionMin={select - 1 > -1}
            conditionAdd={select + 1 < store.calenderRuslt.length}
            onRight={onRight}
            onLeft={onLeft}
            onStart={() => setSelect(0)}
            onEnd={() => setSelect(11)}
          />
        )}
      </div>
    </div>
  ));
}

export default MainPanel;
